import Colors from '../constants/Colors'

export const blueBorder = {
  borderWidth: 2,
  borderColor: Colors.lightBlue,
}
